import { Tooltip } from 'antd'
import { ActionLink, AuditIcon, Container, EditIcon, ViewIcon } from './styles'
import PropTypes from 'prop-types'
import React from 'react'
import { useSave } from '../../Context/saveContext'
import { PERMISSION_CODES } from '../../constants/permissions'
import { useAlertRedirect } from '../../hooks/useAlertRedirect'

export default function HeaderLinks({ email, active }) {
  const { isSaved, userPermissions } = useSave()
  const { show } = useAlertRedirect()
  const getUser = (email) => {
    return email.split('@')[0].toLowerCase()
  }
  const validateChanges = (event, target) => {
    if (!isSaved) {
      event.preventDefault()
      show(target, { email: email })
    } else {
      return true
    }
  }

  return (
    <Container>
      {userPermissions.includes(PERMISSION_CODES.viewProfile.code) && (
        <Tooltip title='View'>
          <ActionLink
            onClick={(event) => validateChanges(event, `/view/${getUser(email)}`)}
            to={`/view/${getUser(email)}`}>
            <ViewIcon size={30} $isActive={active === 'view'} />
          </ActionLink>
        </Tooltip>
      )}
      {userPermissions.includes(PERMISSION_CODES.editProfile.code) && (
        <Tooltip title='Edit'>
          <ActionLink to={`/edit/${getUser(email)}`}>
            <EditIcon size={30} $isActive={active === 'edit'} />
          </ActionLink>
        </Tooltip>
      )}
      {userPermissions.includes(PERMISSION_CODES.viewPeoplesAudit.code) && (
        <Tooltip title='Audit'>
          <ActionLink
            onClick={(event) => validateChanges(event, `/audit/${getUser(email)}`)}
            to={`/audit/${getUser(email)}`}>
            <AuditIcon size={30} $isActive={active === 'audit'} />
          </ActionLink>
        </Tooltip>
      )}
    </Container>
  )
}

HeaderLinks.propTypes = {
  email: PropTypes.string.isRequired,
  active: PropTypes.string.isRequired
}
